const CLASS = 'react_spinner';
export const DEACTIVE_CLASS = `${CLASS}__deactive`;
export const DIRECTION = {
  RTL: 'rtl',
  LTR: 'ltr'
};
export const MODE = {
  FULL: 'full',
  INSIDE: 'inside'
}

export const NAME = {
  BALL_TRIANGLE: 'ball-triangle',
  GRID: 'grid',
  OVAL: 'oval',
  PUFF: 'puff',
  RINGS: 'rings',
  TAIL_SPIN: 'tail-spin',
  THREE_DOTS: 'three-dots',
  UIKIT: 'uikit'
}

export const POSITION = {
  RTL: {
    BOTTOM: 'BOTTOM',
    CENTER: 'CENTER',
    LEFT: 'RIGHT',
    RIGHT: 'LEFT',
    TOP: 'TOP'
  },
  LTR: {
    BOTTOM: 'BOTTOM',
    CENTER: 'CENTER',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    TOP: 'TOP'
  }
}

export const POSITION_MAP = {
  BOTTOM: 'flex_bottom',
  CENTER: 'flex_center',
  LEFT: 'flex_left',
  RIGHT: 'flex_right',
  TOP: 'flex_top'
}

export const RELATIVE_CLASS = `${CLASS}_position__relative`;
